import request from '@/utils/request'

export function fontLibrarySelectInfo(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/font/fontLibrarySelectInfo?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}
export function fontLibraryBatchDelete(data) {
    return request({
        url: `api/serviceCenter/font/fontLibraryBatchDelete`,
        method: 'post',
        data,
    })
}
